import {required,numeric} from "vuelidate/lib/validators";  
const StrKontrolEylem = {
    data() {
      return { 
        StrKontrolEylemData:{ 
            SiraNo:"",
            Kod:"",
            Eylem:"", 
            Deleted: false 
          },
        FormDataType:{ 
          SiraNo:{FieldName:"SiraNo",Field:"input",FieldTitle:this.$t('StrKontrolEylem.AddEdit.SiraNo')},
          Kod:{FieldName:"Kod",Field:"input",FieldTitle:this.$t('StrKontrolEylem.AddEdit.Kod')},
          Eylem:{FieldName:"Eylem",Field:"input",FieldTitle:this.$t('StrKontrolEylem.AddEdit.Eylem')} 
        }   
      }
    },
    validations:{ 
        FormData: {
            SiraNo: {required,numeric },  
            Kod:{  required  }, 
            Eylem: {  required  },   
        } 
    },
}
export default StrKontrolEylem